// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__1+JkV"};